import { useMeterType } from 'hooks/useMeterType';

export const useSupplyStatus = () => {
  const {
    isBGCustomerForElec,
    isBGECustomerForElec,
    isBGECustomerForGas,
    isBGCustomerForGas
  } = useMeterType();
  const isNewToBrandForElec = !isBGCustomerForElec && !isBGECustomerForElec;
  const isNewToBrandForGas = !isBGCustomerForGas && !isBGECustomerForGas;
  const isNepSplitSupply =
    (isBGECustomerForElec && isNewToBrandForGas) ||
    (isBGECustomerForGas && isNewToBrandForElec);
  const isSapSplitSupply =
    (isBGCustomerForElec && isNewToBrandForGas) ||
    (isBGCustomerForGas && isNewToBrandForElec);
  const isMixedNepSap =
    (isBGECustomerForElec && isBGCustomerForGas) ||
    (isBGCustomerForElec && isBGECustomerForGas);

  return {
    isNewToBrandForElec,
    isNewToBrandForGas,
    isNepSplitSupply,
    isSapSplitSupply,
    isMixedNepSap
  };
};
